import { Theme, themeConfig } from 'alurkerja-ui';

export const theme: Theme = {
  ...themeConfig,
  table_wrapper: 'px-0',
  table_head_row: 'bg-white text-slate-400 border',
  table_head_col_no: 'bg-white px-2',
  table_head_col: 'bg-white text-left whitespace-nowrap',
  table_body_col: 'px-0 !py-4 whitespace-nowrap',
  // table_head_col: themeConfig.table_head_col + ' !static',
};
